import { init } from 'commandbar';
import { useEffect, useState } from 'react';

import { useCurrentUser } from '~/hooks/account';

/**
 * @note Initialize the command bar. We aren't currently using
 * it in platform directly but it is called by
 * segment for onboarding "nudges" using query params:
 * /prospector?new=true&tutorial=prospect
 */
init('1ee489c0');

const CommandBar = () => {
  const [booted, setBooted] = useState(false);
  const { data: user } = useCurrentUser();

  useEffect(() => {
    if (!user || booted) return;
    if (!window.CommandBar) return;

    /**
     * Boot the command bar
     * @see https://www.commandbar.com/docs/sdk/lifecycle/boot
     */
    /**
     * To reset nudges use the following in browser console
     * 123 is the ID of the nudge that you can find in local storage
     * object by searching "commandbar"
     * @example window.CommandBar.resetNudge(123, 0);
     * @see https://www.commandbar.com/docs/sdk/nudges/resetnudge/
     */
    window.CommandBar.boot(
      user.id,
      {},
      {
        products: ['nudges'],
      },
    );
    setBooted(true);
  }, [user]);

  return <></>;
};

export { CommandBar };
